import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { CategoryService } from '../../../services/category.service';
import { Category } from 'src/app/models/category/category.module';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { FormBuilder } from '@angular/forms';
declare var $: any;
import { NgbDateStruct, NgbDate, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { TareasService } from '../../../services/tareas.service';
import { Estatus } from '../../../models/category/category.module';
import { GLOBAL_IMAGES } from '../../../services/global.service';


@Component({
  selector: 'app-tareas',
  templateUrl: './tareas.component.html',
  styleUrls: ['./tareas.component.css']
})
export class TareasComponent implements OnInit {
  estatus: Estatus;
  agregar_proyecto: boolean = false;
  ver_info: boolean = false;
  categoria;
  categorias;
  cat: Category;
  cliente;
  activ;
  proyecto_actividad;
  edit_cat: Category;
  edit_act: Category;
  token;
  identity;
  status: string;
  loading: boolean = false;
  loading_edit: boolean = false;
  id_us: number;
  titulo: string;
  cat_edit: string;
  id_edit: number;
  color_edit: string;
  url: string;
  array: Array<any> = [];
  actividad;
  agregar_usuario;
  //add
  aform: boolean = false;
  edform: boolean = false;
  realizadas: boolean = false;
  edit_tarea;
  agrega_usuario: boolean = false;
  model: NgbDateStruct;
  time = { hour: 13, minute: 30 };
  time2 = { hour: 13, minute: 30 };
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  ver_tarea;
  public options: Object = {
    placeholderText: 'Escribe un comentario',
    charCounterCount: false
  }

  constructor(private _userService: UserService, private _categoryService: CategoryService, private _tareasService: TareasService, public router: Router,
    private calendar: NgbCalendar, public formatter: NgbDateParserFormatter, private _location: Location) {

    //console.log(_categoryService.category);
    if (!_categoryService.category?.id) {
      this.router.navigateByUrl('/home');
      this.fromDate = calendar.getToday();
      this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
    }
    this.url = GLOBAL_IMAGES.url;
    let user = this._userService.getIdentity();
    let token = this._userService.getToken();
    this.id_us = user.sub;
    this.cat = new Category(1, '', user.sub, '#007bffff', user.email, 0);
    this.edit_cat = new Category(1, '', user.sub, '#007bffff', '', 0);
    this.edit_act = new Category(1, '', user.sub, '#007bffff', '', 0);
    // this.activ = new Category(1,'',user.sub,'#007bffff','',0);
    this.titulo = _categoryService.category?.categoria;
    this.cat = _categoryService.category;
    this.activ = _categoryService.activ;
    this.cat.valor = user.email;
    this.edit_cat = _categoryService.category;
    this.token = token;
    this.verTareas();
    this.array = this.categoria;
    //console.log(this.cat);
    this.cliente = this.cat;
    // console.log(this.cliente);
    // console.log(cat.category.categoria);
    // Get NavigationStart events

  }

  ngOnInit(): void {
    $('select').selectpicker();

  }
  backClicked() {
    //console.log("click");
    this._location.back();
  }
  cerrarForm() {
    this.ver_info = false;
    this.verTareas();
    this.array = [];
    setTimeout(() => {
      this.aform = false;
    }, 400);
  }
  cerrarFormEdit() {
    this.ver_info = false;
    this.verTareas();
    this.array = [];
    setTimeout(() => {
      this.edform = false;
    }, 400);
  }
  abrirForm(cat, i) {
    this.array = [];
    this.array.push(cat);
    this.categoria = this.array;
    // this.categoria.id = cat?.actividad.id_act;
    this.actividad = i;
    //console.log("abrir form");
    //console.log(this.array[0]['actividad']['id_act']);
    this._categoryService.activ = this.array[0]['actividad']['id_act'];
    this.proyecto_actividad = this.array[0]['actividad']['id_act'];
    this.ver_info = false;
    this.edform = false;
    this.aform = true;
  }
  abrirFormEdit(cat, i, num) {
    this.ver_info = false;
    this.aform = false;
    this.edform = true;
    this.array = [];
    this.array.push(cat);
    this.edit_tarea = this.array;
    this.edit_tarea.tipo = num;
    this.actividad = i;
    //console.log("abrir form edit");
    this._categoryService.edit_tarea = this.edit_tarea;
  }
  cargar_datos() {
    this.actualiza(this.actividad);
  }
  abrirInfo(tarea) {
    this.aform = false;
    this.edform = false;
    this.ver_info = true;
    this.ver_tarea = tarea;
  }
  cerrarInfo() {
    this.aform = false;
    this.ver_info = false;
  }
  cierra_agrega_usuario() {
    this.agrega_usuario = false;
  }
  abre_agrega_usuario() {
    //console.log(this.cat);

    this.agrega_usuario = true;
    this.aform = false;
    this.ver_info = false;
  }

  eliminaruserclient(id) {

  }
  eliminaruserproyect(id) {

  }

  agregar_actividad() {
    (async () => {

      const { value: name } = await Swal.fire({
        title: 'Agregar Actividad',
        input: 'text',
        inputPlaceholder: 'Ingrese el nombre de la Actividad',
        showCancelButton: true
      })
      if (name) {
        this.edit_cat.categoria = name;

        this._tareasService.addActividad(this.edit_cat, this.token).subscribe(
          response => {
            this.verTareas();
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: response.message,
              showConfirmButton: false,
              timer: 1500
            });
          },
          error => {
            console.log(error);
            const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
            this._userService.register_error(message_error, this.token).subscribe(
              response2 => {
                Swal.fire({
                  position: 'top-end',
                  icon: 'warning',
                  title: response2.message,
                  showConfirmButton: false,
                  timer: 2000
                });
              },
              error => {
                console.log(error);
              }
            );
          }
        );
      }
    })();
  }
  ed_actividad(info) {
    //console.log(info.actividad.id_act);
    (async () => {
      const { value: name } = await Swal.fire({
        title: 'Agregar Actividad',
        input: 'text',
        inputValue: info.actividad.actividad,
        inputPlaceholder: 'Ingrese el nombre de la Actividad',
        showCancelButton: true
      })
      if (name) {
        this.edit_act.categoria = name;
        this.edit_act.id = info.actividad.id_act;
        this._tareasService.edActividad(this.edit_act, this.token).subscribe(
          response => {
            this.verTareas();
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: response.message,
              showConfirmButton: false,
              timer: 1500
            });
          },
          error => {
            console.log(error);
            const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
            this._userService.register_error(message_error, this.token).subscribe(
              response2 => {
                Swal.fire({
                  position: 'top-end',
                  icon: 'warning',
                  title: response2.message,
                  showConfirmButton: false,
                  timer: 2000
                });
              },
              error => {
                console.log(error);
              }
            );
          }
        );
      }
    })();
  }
  del_actividad(info) {

    Swal.fire({
      title: '¿Eliminar la actividad?',
      text: "Desea eliminar la actividad",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar'
    }).then((result) => {
      if (result.value) {
        this.edit_act.id = info.actividad.id_act;
        this._tareasService.delActividad(this.edit_act, this.token).subscribe(
          response => {
            this.verTareas();
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: response.message,
              showConfirmButton: false,
              timer: 1500
            });
          },
          error => {
            console.log(error);
            const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
            this._userService.register_error(message_error, this.token).subscribe(
              response2 => {
                Swal.fire({
                  position: 'top-end',
                  icon: 'warning',
                  title: response2.message,
                  showConfirmButton: false,
                  timer: 2000
                });
              },
              error => {
                console.log(error);
              }
            );
          }
        );

      }
    })


  }
  verTareas() {
    this.realizadas = false;
    this._categoryService.getTareas(this.cat, this.token).subscribe(
      response => {
        this.categoria = response;
        //console.log(this.categoria);
      },
      error => {
        console.log(error);
        const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(error);
          }
        );
      }
    );
  }
  tareas_realizadas() {
    this.realizadas = true;
    this._categoryService.getTareasRealizadas(this.cat, this.token).subscribe(
      response => {
        this.categoria = response;
        //console.log(this.categoria);
      },
      error => {
        console.log(error);
        const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(error);
          }
        );
      }
    );
  }

  actualiza(i) {
    this._categoryService.getTareas(this.cat, this.token).subscribe(
      response => {
        //console.log("tareas");
        this.array = [];
        this.array.push(response[i]);

        this.categoria = this.array;

        //console.log(this.categoria);
        //console.log(this.array);
        //console.log(response[i]);

        //if(response.status == 'success'){
        //	this.categoria = response.array;
        //}
      },
      error => {
        console.log(error);
        const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(error);
          }
        );
      }
    );
  }

  onSubmitImportancia(form) {
    //console.log(this.categoria);
    //console.log(form.value);
    //console.log(form.value.num);
    this.categoria[form.value.cat].tareas.tareas[form.value.num].num_importancia = form.value.importancia;
    if (form.value.importancia == 1) {
      this.categoria[form.value.cat].tareas.tareas[form.value.num].importancia = 'Bajo';
      this.categoria[form.value.cat].tareas.tareas[form.value.num].importancia_color = 'badge-success';
    } else if (form.value.importancia == 2) {
      this.categoria[form.value.cat].tareas.tareas[form.value.num].importancia = 'Media';
      this.categoria[form.value.cat].tareas.tareas[form.value.num].importancia_color = 'badge-info';
    } else if (form.value.importancia == 3) {
      this.categoria[form.value.cat].tareas.tareas[form.value.num].importancia = 'Alta';
      this.categoria[form.value.cat].tareas.tareas[form.value.num].importancia_color = 'badge-danger';
    } else {
      this.categoria[form.value.cat].tareas.tareas[form.value.num].importancia = 'Importancia';
      this.categoria[form.value.cat].tareas.tareas[form.value.num].importancia_color = 'badge-success';
    }

    this.estatus = new Estatus(form.value.id_tarea, form.value.importancia, form.value.num);
    //console.log(this.estatus);
    this._categoryService.editImportancia(this.estatus, this.token).subscribe(
      response => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Se actualizó el estatus correctamente',
          showConfirmButton: false,
          timer: 1500
        });
      },
      error => {
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Ocurrio un error, no se actualizó',
          showConfirmButton: false,
          timer: 1500
        });
        console.log(error);
        const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(error);
          }
        );
      }
    );


  }

  onSubmitEstatus(form) {
    //console.log(form.value);

    this.estatus = new Estatus(form.value.id_tarea, form.value.estatus, form.value.num);
    //console.log(this.estatus);
    this.categoria[form.value.cat].tareas.tareas[form.value.num].id_estatus = form.value.estatus;

    this._categoryService.editEstatus(this.estatus, this.token).subscribe(
      response => {
        this.categoria[form.value.cat].tareas.tareas[form.value.num].estatus = response.estatus;
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Se actualizó el estatus correctamente',
          showConfirmButton: false,
          timer: 1500
        });
      },
      error => {
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Ocurrio un error, no se actualizó',
          showConfirmButton: false,
          timer: 1500
        });
        console.log(error);
        const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(error);
          }
        );
      }
    );

  }

  eliminartarea(id_tarea, i) {
    this.estatus = new Estatus(id_tarea, 0, 0);
    Swal.fire({
      title: '¿Eliminar la Tarea?',
      text: "Desea eliminar la Tarea",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar'
    }).then((result) => {
      if (result.value) {

        this._tareasService.taskDel(this.estatus, this.token).subscribe(
          response => {
            //console.log(response);
            this.categoria[0].tareas.tareas.splice(i, 1);
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: response.message,
              showConfirmButton: false,
              timer: 1500
            });
          },
          error => {
            console.log(error);
            const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
            this._userService.register_error(message_error, this.token).subscribe(
              response2 => {
                Swal.fire({
                  position: 'top-end',
                  icon: 'warning',
                  title: response2.message,
                  showConfirmButton: false,
                  timer: 2000
                });
              },
              error => {
                console.log(error);
              }
            );
          }
        );
      }
    });
  }


}
